import React from 'react';
import { AppHeaderDesktop } from '@/components/AppHeader/AppHeaderDesktop';
import { useCurrentPage } from '@/hooks/useCurrentPage';
import PropTypes from 'prop-types';

export function AppHeaderContainerDesktop(props) {
  const currentPage = useCurrentPage();
  return <AppHeaderDesktop page={currentPage} {...props} />;
}

AppHeaderContainerDesktop.propTypes = {
  title: PropTypes.string.isRequired,
};
